export default __webpack_public_path__ + "static/media/checkmark.ccfb0f98.svg";